import TemplateView from "../../../TemplateView";

export default class Header extends TemplateView {

    constructor() {
        super(null)
    }

    templateHtml() {
        return '<table class="dialog-header">' +
               '    <tr>' +
               '        <td>' +
               '            <div class="close-button">' +
               '                <div id="customerLightBoxCloseButton" class="closeButton"></div>' +
               '                <div class="disabledCloseButton"></div>' +
               '            </div>' +
               '' +
               '            <div class="lightBoxTitle">' +
               '                <span id="<%=id%>_titlePlaceholder"><%-title%></span>' +
               '            </div>' +
               '        </td>' +
               '    </tr>' +
               '</table>'
    }


    messageKeys() {
        return {
            title: 'customer.create.popup.title'
        }
    }

    getCloseButtonEl() {
        return this.find('.closeButton')
    }
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/createLightbox/customer/Header.js